"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_HTTPS_PORT = 443;
exports.DEFAULT_HTTP_PORT = 80;
exports.SCHEME_HTTP = 'http';
exports.SCHEME_HTTPS = 'https';
//# sourceMappingURL=constants.js.map